export default __webpack_public_path__ + "static/media/tempo-play-embed.2bc1b31c.svg";